import React from "react";
import { ForfeitureContainer } from "../../../containers";

const Forfeiture = (props) => {
  return <ForfeitureContainer {...props} />;
};

export default Forfeiture;
